import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
// utils
import { fDateTime } from 'src/utils/formatTime';
// components
import Label from 'src/components/Label';
import Iconify from 'src/components/Iconify';
import { TableCell, TableRow } from 'src/@/components/ui/table';
import { Button } from 'src/@/components/ui/button';

// ----------------------------------------------------------------------

export default function SupervisaoRow({ row, selected, onViewRow, loading, chat }) {
    const theme = useTheme();
    const {
        numeroCliente,
        nomeCliente,
        nome_cliente,
        dataCriacao,
        statusRoom,
        chatbot,
        cliente_id,
        lastUpdate,
        nome_setor,
        nome_usuario,
        novaMensagem,
        analyse,
    } = row;

    const [setOpenMenuActions] = useState(null);

    const handleCloseMenu = () => {
        setOpenMenuActions(null);
    };

    const mappSentiment = {
        1: { label: 'Raiva', bg: 'bg-red-100 border-red-200 text-red-700', icon: 'emotion-angry' },
        2: { label: 'Frustração', bg: 'bg-orange-100 border-orange-200 text-orange-500', icon: 'emotion-sad' },
        3: { label: 'Neutro', bg: 'bg-gray-100 border-gray-200 text-gray-700', icon: 'emotion-normal' },
        4: { label: 'Satisfeito', bg: 'bg-green-100 border-green-200 text-green-700', icon: 'emotion-happy' },
        5: { label: 'Muito Satisfeito', bg: 'bg-blue-100 border-blue-200 text-blue-700', icon: 'emotion-satisfied' },
        negative: { label: 'Negativo', bg: 'bg-red-100 border-red-200 text-red-700', icon: 'emotion-unhappy' },
        neutral: { label: 'Neutro', bg: 'bg-gray-100 border-gray-200 text-gray-700', icon: 'emotion-normal' },
        positive: { label: 'Positivo', bg: 'bg-green-100 border-green-200 text-green-700', icon: 'emotion-happy' },
    };

    return (
        <TableRow className="hover:bg-gray-50 transition-colors">
            <TableCell>
                <Label
                    variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    color={
                        (statusRoom === 'Finalizado' && 'success') ||
                        (statusRoom === 'Pendente' && 'error') ||
                        (statusRoom === 'Atendendo' && 'warning') ||
                        (statusRoom === 'Geral' && 'info') ||
                        'default'
                    }
                    sx={{ textTransform: 'capitalize' }}
                >
                    {statusRoom}
                </Label>
            </TableCell>

            <TableCell>{numeroCliente}</TableCell>

            <TableCell>{nomeCliente ? nomeCliente : nome_cliente}</TableCell>

            <TableCell>{nome_usuario}</TableCell>

            <TableCell>{nome_setor}</TableCell>

            <TableCell>{fDateTime(lastUpdate)}</TableCell>

            <TableCell>{fDateTime(dataCriacao)}</TableCell>

            <TableCell>
                <Label
                    variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    color={(chatbot === true && 'default') || (chatbot === false && 'default') || 'default'}
                    sx={{ textTransform: 'capitalize' }}
                >
                    {chatbot ? 'Ativado' : 'Desativado'}
                </Label>
            </TableCell>

            <TableCell>
                {row?.sentiment ? (
                    <Label
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={
                            (row?.sentiment === '1' && 'error') ||
                            (row?.sentiment === '2' && 'warning') ||
                            (row?.sentiment === '3' && 'default') ||
                            (row?.sentiment === '4' && 'info') ||
                            (row?.sentiment === '5' && 'success') ||
                            'default'
                        }
                        sx={{ textTransform: 'capitalize' }}
                    >
                        {mappSentiment[row?.sentiment]?.label} ({row?.sentiment})
                    </Label>
                ) : (
                    <div />
                )}
            </TableCell>

            <TableCell>
                <Button
                    onClick={() => {
                        onViewRow();
                    }}
                    size="icon"
                    variant="outline"
                >
                    <Iconify icon={'carbon:view-filled'} />
                </Button>
            </TableCell>
        </TableRow>
    );
}